import * as React from 'react';
import './currentPlanSummary.module.scss';
import { ItemPriceSummary, SimpleItemPriceSummary } from '../../../atoms/applications/planOptions';
import { DetailedDate2, SimpleDateRange2 } from '../../../../../admin/components/date/TimeRange';
import { observer } from 'mobx-react';
import { GlobalStatesV3 } from '../../../../../commonv3/states/GlobalStatesV3';
import { SubscriptionSummary } from '../../../../types/subscriptionSummary';
import moment from 'moment-timezone';

type Props = {
    summary: SubscriptionSummary;
};

export const CurrentPlanSummary = observer(({ summary }: Props) => {
    const updateDate = moment(summary.next_updatable_date);
    return (
        <div id="current-plan-summary" styleName="current-plan-summary">
            <div styleName="header">
                <div styleName="plan-label">現在お申し込みのプラン</div>
                <div styleName="plan-name">{summary.plan_name}</div>
                <div styleName="plan-price">
                    {GlobalStatesV3.viewport.isMobile ? (
                        <SimpleItemPriceSummary
                            durationMonth={summary.plan_item_duration_month}
                            price={summary.plan_item_price}
                        />
                    ) : (
                        <ItemPriceSummary
                            durationMonth={summary.plan_item_duration_month}
                            discount={0}
                            price={summary.plan_item_price}
                        />
                    )}
                </div>
            </div>
            <div styleName="splitter" />
            <div styleName="footer">
                <div styleName="membership-period">
                    <div styleName="label">受講期間</div>
                    <div styleName="period">
                        <SimpleDateRange2 fromDate={summary.starts_at} toDate={summary.strict_expires_at} />
                    </div>
                </div>
                {updateDate && (
                    <div styleName="update-notice">
                        現在プランの受講期間中のためプラン変更が適用されるのは<DetailedDate2 date={updateDate} />からとなります。
                    </div>
                )}
            </div>
        </div>
    );
});
